import { addToAcceptPolityCookies } from './addAcceptPolity';
import { addToCartSuccessSetCookies } from './addToCart';
import { addRejectZipcodePopup } from './addRejectZipcodePopup';
import { setPageBeforeLogin } from './setPageBeforeLogin';
var events = {
  'addtoacceptpolity:success': [addToAcceptPolityCookies],
  'addtocart:success': [addToCartSuccessSetCookies],
  'addtorejectzipcode:success': [addRejectZipcodePopup],
  setpagebeforelogin: [setPageBeforeLogin]
};
export default events;